import '../util/numberFormat.js';

export default {
    init() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/FuelSaving.js